import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import ComparePEORatesWrapper from "@components/layouts/comparepeoratesWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function ComparePEORatesHome(): ReactElement {
    return (
        <ComparePEORatesWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Compare PEO Rates"
                    domain="ComparePEORates.com"
                />
            </div>
        </ComparePEORatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
